<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <!-- Creator: CorelDRAW 2020 (64 Bit) -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="1000px"
    height="808px"
    version="1.1"
    style="
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      image-rendering: optimizeQuality;
      fill-rule: evenodd;
      clip-rule: evenodd;
    "
    viewBox="0 0 25.92 20.94"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
  >
    <defs></defs>
    <g id="Layer_x0020_2">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <path
        class="fil0"
        d="M12.07 4.1c2.85,-0.01 5.7,0 8.55,-0.01 0.43,0 4.2,-0.04 4.28,0.02 0.08,0.05 0.04,0.86 0.04,1.02l0 13.94c0,0.97 -0.62,0.91 -1.22,0.91l-21.43 0c-0.35,0 -0.68,0.05 -0.96,-0.12 -0.23,-0.13 -0.33,-0.38 -0.33,-0.74 0.02,-3.54 -0.01,-7.17 -0.01,-10.72 0,-0.49 -0.03,-4.1 0.01,-4.27 0.17,-0.04 1.12,-0.01 1.38,-0.01l9.69 -0.02zm-6.93 4.97c0.2,-0.03 1.61,-0.01 1.93,-0.01l5.89 -0.01c0.76,0 7.72,-0.03 7.84,0.02 0.03,0.28 0.01,3.66 0.01,4.03 0,0.67 0,1.35 0,2.02 0,0.36 0.05,1.75 -0.05,1.98 -0.12,0.27 -0.33,0.31 -0.69,0.31 -0.33,0 -0.67,0 -1,0l-6.09 0c-1.34,0 -2.69,0 -4.04,0.01l-3.03 0c-0.37,0 -0.6,-0.03 -0.73,-0.3 -0.1,-0.22 -0.05,-1.62 -0.05,-1.97 0,-0.68 0,-1.36 0,-2.03 0,-0.31 -0.02,-3.83 0.01,-4.05zm2.5 -1.41c-0.09,-0.39 0.18,-0.68 0.46,-0.75 0.38,-0.09 0.69,0.18 0.76,0.47 0.17,0.82 -1.03,1.06 -1.22,0.28zm1.92 -0.04c-0.1,-0.86 1.1,-0.99 1.23,-0.2 0.06,0.37 -0.21,0.66 -0.52,0.71 -0.36,0.06 -0.67,-0.22 -0.71,-0.51zm-3.86 -0.02c-0.08,-0.85 1.14,-0.95 1.24,-0.16 0.1,0.83 -1.16,0.95 -1.24,0.16zm16.04 9.42c0.02,-0.21 0.01,-1.54 0.01,-1.87l0 -7.51c0,-0.32 0.01,-0.56 -0.09,-0.85 -0.08,-0.23 -0.24,-0.44 -0.37,-0.56 -0.46,-0.41 -0.73,-0.41 -1.48,-0.41l-13.13 0.02c-0.58,0 -1.24,-0.07 -1.72,0.17 -0.36,0.19 -0.7,0.57 -0.77,1.11 -0.03,0.23 -0.01,1.54 -0.01,1.89l0 7.51c0,0.43 -0.01,0.81 0.26,1.17 0.47,0.65 0.95,0.65 1.69,0.65l13.16 0c0.6,0 1.21,0.07 1.69,-0.19 0.36,-0.19 0.7,-0.59 0.76,-1.13zm-16.88 -15.59c0.43,-0.05 0.79,0.29 0.84,0.67 0.06,0.45 -0.28,0.8 -0.66,0.85 -0.98,0.14 -1.21,-1.39 -0.18,-1.52zm2.44 0c0.43,-0.06 0.8,0.29 0.84,0.67 0.12,1.02 -1.4,1.17 -1.51,0.17 -0.05,-0.45 0.28,-0.78 0.67,-0.84zm-4.9 0c0.42,-0.06 0.79,0.29 0.85,0.65 0.06,0.46 -0.28,0.82 -0.66,0.87 -0.96,0.13 -1.24,-1.35 -0.19,-1.52zm12.46 -1.41l-12.77 0.02c-0.7,0 -1.06,0.05 -1.49,0.43 -0.33,0.29 -0.59,0.69 -0.59,1.34 -0.02,4.31 0,8.62 0.01,12.92l0 4.5c0,0.98 0.79,1.72 1.79,1.71l22.37 0c0.98,-0.01 1.73,-0.77 1.74,-1.74l0 -17.45c0,-0.28 -0.06,-0.53 -0.17,-0.75 -0.2,-0.42 -0.53,-0.73 -0.97,-0.89 -0.43,-0.16 -1.29,-0.1 -1.83,-0.1l-8.09 0.01z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
